export const COUNTRIES = { name: "countries", identifier: "countryCode" };
export const LANGUAGE_CODES = { name: "languages", identifier: "languageCode" };
export const PROVINCES = { name: "provinces", identifier: "provinceCode" };
export const ROLES = { name: "roles", identifier: "roleId" };
export const FOLLOW_UP_CATEGORIES = {
  name: "follow-up-categories",
  identifier: "followUpCategoryId",
};



// WEBPACK FOOTER //
// ./src/utils/enums/enums.js